<div>
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">
        Paridades <strong>{{ data.moneda }}</strong>
      </h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="dateToSearch"
          (change)="getParidadXFecha(data.moneda)"
          pTooltip="Buscar por fecha"
          tooltipPosition="bottom"
          (keydown)="preventTyping($event)"
          style="width: 120px"
          appPermissionControl="P110K0001"
        />
        <span class="p-input-icon-left search-input">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Buscar..."
            class="p-inputtext-sm"
            [(ngModel)]="valueToSearch"
            appPermissionControl="P110K0002"
          />
        </span>
        <p-button icon="pi pi-refresh" (onClick)="getParidadXmoneda(data.moneda)" pTooltip="Refrescar tabla" tooltipPosition="bottom" appPermissionControl="P110B0001"></p-button>
        <button mat-flat-button (click)="abrirModal()" class="btn-new" appPermissionControl="P110B0002">
          <mat-icon>add</mat-icon>
          Nuevo
        </button>
        <button mat-flat-button (click)="closeParidades()" class="btn-back" appPermissionControl="P110B0003">
          <mat-icon>close</mat-icon>
          Cerrar
        </button>
      </div>
    </div>
  </div>

  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 15, 20]"
    [scrollable]="true"
    scrollHeight="700px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [globalFilterFields]="['moneda', 'descripcion', 'fecha_Ultima', 'factor', 'responsable']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P110T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P110C0001">
          {{ col.header }}
          @if(col.field !== 'actions') {
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex gap-2 justify-content-center">
                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-help p-button-text" (click)="abrirModal(rowData)" appPermissionControl="P110B0004"></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="deleteParidad(rowData.moneda, rowData.fecha)"
                  appPermissionControl="P110B0005"
                ></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fecha_Ultima'">
              {{ this._helpers.convertJulianasToGregorianas(rowData.fecha_Ultima) }}
            </ng-container>
            <ng-container *ngSwitchCase="'moneda'">
              <strong>{{ rowData[col.field] }}</strong>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="{{ isEdit ? 'Editar Paridad' : 'Nueva Paridad' }}"
  [(visible)]="visibleModal"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="visibleModal = false; form.reset()"
>
  <form [formGroup]="form" style="margin-top: 20px" appPermissionControl="P110F0001">
    <div class="form-row">
      <div class="form-field">
        <label>Moneda</label>
        <input pInputText formControlName="moneda" class="form-control" appPermissionControl="P110K0003" />
      </div>
      <div class="form-field">
        <label>Fecha</label>
        <input pInputText type="date" formControlName="fecha" class="form-control" appPermissionControl="P110K0004" />
      </div>
      <div class="form-field">
        <label>Factor</label>
        <input pInputText type="number" formControlName="factor" class="form-control" placeholder="0.000" appPermissionControl="P110K0005" />
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="button-section">
      <button mat-flat-button class="btn-success" (click)="saveParidad()" [disabled]="!form.valid" appPermissionControl="P110B0006">
        <mat-icon>save</mat-icon>
        {{ isEdit ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
